import { createSlice } from '@reduxjs/toolkit';
import { loadQuestionnaire, uploadTraitStrengthMapping } from './onboardingThunk';

export const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState: {
      questionnaire: [],
      questionsLoading: false,
      questionsLoadingError: false,
      questionsLoadingErrorMessage: null,
      uploadingTraitStrengths: false,
      uploadingTraitStrengthsError: false,
      uploadingTraitStrengthsErrorMessage: null,
      previousAnswers: null,
    },
    reducers: {
      setQuestionnaire: (state, action) => {
        state.questionnaire = action.payload;
      },
      setQuestionsLoading: (state, action) => {
        state.questionsLoading = action.payload;
      },
      setQuestionsLoadingError: (state, action) => {
        state.questionsLoadingError = action.payload;
      },
      setPreviousAnswers: (state, action) => {
        state.previousAnswers = action.payload;
      },
      setQuestionsLoadingErrorMessage: (state, action) => {
        state.questionsLoadingErrorMessage = action.payload;
      },
    },
    extraReducers: builder => {
      builder
        .addCase(loadQuestionnaire.pending, (state) => {
          state.questionsLoading = true
        })
        .addCase(loadQuestionnaire.fulfilled, (state, action) => {
          const { questionnaire, previousAnswers } = action.payload;
          state.questionnaire = questionnaire;
          state.previousAnswers = previousAnswers;
          state.questionsLoading = false
          state.questionsLoadingError = false;
          state.questionsLoadingErrorMessage = null;
        })
        .addCase(loadQuestionnaire.rejected, (state) => {
          state.questionsLoadingError = true;
          state.questionsLoadingErrorMessage = "Error loading questions. Please try again later.";
          state.questionsLoading = false;
        })
        .addCase(uploadTraitStrengthMapping.pending, (state) => {
          state.uploadingTraitStrengths = true
        })
        .addCase(uploadTraitStrengthMapping.fulfilled, (state) => {
          state.uploadingTraitStrengths = false
          state.uploadingTraitStrengthsError = false;
          state.uploadingTraitStrengthsErrorMessage = null;
        })
        .addCase(uploadTraitStrengthMapping.rejected, (state) => {
          state.uploadingTraitStrengths = false;
          state.uploadingTraitStrengthsError = true;
          state.uploadingTraitStrengthsErrorMessage = "Error uploading trait strengths. Please try again later.";
        });
    }
});

export const {
    setQuestionnaire,
    setQuestionsLoading,
    setQuestionsLoadingError,
    setPreviousAnswers,
    setQuestionsLoadingErrorMessage
} = onboardingSlice.actions;